define('components/dealer-panel-components',[
  'jquery',
  'components/dealer-panel',
  'responsive',
  'cookies',
  'lib/getParameterByName',
  'lib/util/tda.config',
  'lib/util/zip',
  'tabControl',
  'Maps',
  'lib/util/buildGoTo',
  'features/ctas/index',
  'zipTools',
  'webStorage',

  // side effect includes
  'lib/helpers/toJSON', // used by template-dealer-panel-result-pma
  'lib/helpers/ifCond', // used by template-dealer-panel-result-pma & template-dealer-panel-result-confirmation
  'bat'
], function (
  $,
  DealerPanel,
  responsive,
  cookies,
  getParameterByName,
  tdaConfig,
  zip,
  tabControl,
  buildMap,
  buildGoTo,
  ctas,
  zipTools,
  ws
) {
  var dealerPanelComponents = {
    load: function () {
      $(document).ready(function () {
        // For Dealer Specials Page - Start
        // TODO: is this still a page?
        var locationPath = window.location.pathname;
        if (locationPath != null && locationPath != '' && typeof locationPath !== 'undefined' && $.trim(locationPath) != '' && locationPath.indexOf('dealer-specials.page') != -1) {
          var zipCodeForDealer = getParameterByName('zipCode');
          var tdaCodeForDealer = getParameterByName('tdaCode');
          var pmaDealerCodes = getParameterByName('dealerCodes');
          $.ajax({
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            url: '/BATWS/geo/rest/searchMode/getDealerDetails',
            data: {
              begin: 1,
              end: 5,
              zipcode: zipCodeForDealer,
              tdacode: tdaCodeForDealer
            },
            dataType: 'json',
            success: function (data) {
              if (data.dealerLocator.length > 0) {
                $.each(data.dealerLocator, function (i, dealerDetailLine) {
                  if (pmaDealerCodes.indexOf(dealerDetailLine.dealerLocatorDetail.dealerParty.partyID.value) != -1) {
                    var externalDealerSite = '';
                    $.each(dealerDetailLine.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].uricommunication, function (index, value) {
                      if (value.channelCode.value == 'Website') {
                        externalDealerSite = value.uriid.value;
                      }
                    });

                    $('body').append('<div class="dealer-entry col-md-4 col-sm-6 pad-bottom-4-sm"><div class="dealer marg-bottom-0-sm pad-bottom-0-sm"><strong>' + dealerDetailLine.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value + '</strong></div><h6 class="marg-top-0-sm pad-top-0-sm">' + dealerDetailLine.dealerLocatorDetail.dealerParty.specifiedOrganization.divisionCode.name + ', ' + dealerDetailLine.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].postalAddress.stateOrProvinceCountrySubDivisionID.value + '<br>' + dealerDetailLine.dealerLocatorDetail.proximityMeasureGroup.proximityMeasure.value + ' miles away</h6> <div class="btn-cont col-md-4 col-sm-6 pad-left-0-sm"><button data-dismiss="modal" modal-select="34085" class="btn btn-primary modal-select" onclick="window.open(\'' + externalDealerSite + '\',"_blank")" type="button">Select</button></div></div>');
                  }
                });
              }
            },
            error: function (f, b, a) {
              console.warn('Error');
            }
          });
        }

        // Dealer Search Panel on Confirmation page (SLP FORM THANK YOU PAGE)
        // TODO, move this outta here
        if ($('#dealer-search-panel').length && $('#confirmation').length) {
          var tempDealerCode = ws.getSessionStorage().getItem('tempDealerCode') || getParameterByName('dealercode');
          var Panel = new DealerPanel({
            $form: $('#dealer-search-panel'),
            $selectSearchType: $('#dealer-panel-search #search-type select'),
            // $inputText: $('#dealer-panel-search #search-value'),
            $inputText: $('#dealer-search-panel .js-search-value'), // BAT-4293
            $submit: $('#dealer-panel-search #search-submit'),
            $resultsContainer: $('.search-results-wrap'),
            displayDealerCode: tempDealerCode,
            panelSearch: true,
            zipRedirectPath: zipTools.getSiteHomePath() + 'offers/',
            maxResults: 3,
            onSearchComplete: function (data) {
              for (var i = 0; i < data.length; i += 1) {
                var item = data[i];
                item.site_context = buildGoTo(item.tda_code, '/dealer-detail/?dealercode=' + item.dealer_code);
              }
              this.$resultsContainer.removeClass(function (index, css) {
                return (css.match(/\bis-\S+/g) || []).join(' ');
              });

              var providerId = $('#defaultzipcode').attr('providerid');
              var deferredChatPresences = [];
              var that = this;
              data[0].providerId = providerId;
              deferredChatPresences.push(window.bat.dealerChatPresence(providerId, data[0].dealer_code, 'dealercomponentchat'));

              $.when.apply(this, deferredChatPresences).done(function () {
                var responseArr = arguments;
                if (responseArr[0].showOnDealerComponent === true) {
                  data[0].clickToChat = responseArr[0].isOnline;
                }
                that.$form.addClass('view-search-results view-preferred-result');
                var resultTemplate = $('#template-dealer-panel-result-confirmation').html();
                var resultHandlebar = Handlebars.hcompile(resultTemplate, {
                  result: data
                });

                $('.data-search-panel-results').html(resultHandlebar);
                // ensure links to different TDA get a warning message
                $('.data-search-panel-results a[data-tda-code]')
                  .off('click', zipTools.warnOnTDAChange)
                  .on('click', zipTools.warnOnTDAChange);
              });
            }
          });
        }
        // Dealer Search Panel, but NOT on a RAQ/ SATD / CAD page
        // IF this dealer-search-panel IS on a RAQ, SATD, or CAD page
        // use the results from RAQ, etc search, below, to update the component
        else if ($('#dealer-search-panel').length) {
          var Panel = new DealerPanel({
            $form: $('#dealer-search-panel'),
            $selectSearchType: $('#dealer-panel-search #search-type select'),
            // $inputText: $('#dealer-panel-search #search-value'),
            $inputText: $('#dealer-search-panel .js-search-value'), // BAT-4293
            $submit: $('#dealer-panel-search #search-submit'),
            $resultsContainer: $('.search-results-wrap'),
            panelSearch: true,
            withinTDACode: zipTools.getCurrentTDACode(),
            autoSearch: cookies.getItem('isConfirmedZip') === 'true',
            zipRedirectPath: zipTools.getSiteHomePath() + 'offers/',
            maxResults: 5,

            onSearchComplete: function (data) {
              this.$resultsContainer.removeClass(function (index, css) {
                return (css.match(/\bis-\S+/g) || []).join(' ');
              });

              var panelData = [];
              var resultTemplate;
              var resultHandlebar;
              var pmasExist = false;
              var providerId = $('#defaultzipcode').attr('providerid');
              var deferredChatPresences = [];
              var that = this;

              // is first dealer a pma
              if (data.length) {
                // to simulate multiple results, set first dealer is_pma to false
                // data[0].is_pma = false;

                for (var i = 0; i < data.length; i++) {
                  if (data[i].is_pma) {
                    panelData.push(data[i]);
                    pmasExist = true;
                  }
                }

                if (pmasExist === true) {
                  console.debug('panelData.length: ', panelData);
                  if (panelData.length === 1) {
                    resultTemplate = $('#template-dealer-panel-result-pma').html();
                  } else {
                    resultTemplate = $('#template-dealer-panel-result-multiple').html();
                  }
                } else {
                  panelData = data;
                  resultTemplate = $('#template-dealer-panel-result-multiple').html();
                }
              }

              if (panelData.length) {
                // BAT-2633, show "Chat with Dealer" link, if dealer is online, and if TDA_config "show dealer component Chat With Dealer" toggle is set to "yes"
                for (var i = 0; i < panelData.length; i++) {
                  panelData[i].providerId = providerId;
                  deferredChatPresences.push(window.bat.dealerChatPresence(providerId, panelData[i].dealer_code, 'dealercomponentchat'));
                }

                $.when.apply(this, deferredChatPresences).done(function () {
                  var responseArr = arguments;
                  for (var j = 0; j < panelData.length; j++) {
                  // if the responseArr permits us to show CTA on dealer component,
                  // then update our current panelData obj with it's contactatonce online status
                    if (responseArr[j].showOnDealerComponent === true) {
                      panelData[j].clickToChat = responseArr[j].isOnline;
                    }
                  }

                  that.$form.addClass('view-search-results view-preferred-result');
                  // console.log("Scion Dealer2: ", panelData);
                  resultHandlebar = Handlebars.hcompile(resultTemplate, {
                    result: panelData
                  });
                  $('.data-search-panel-results').html(resultHandlebar);
                  // ensure links to different TDA get a warning message
                  $('.data-search-panel-results a[data-tda-code]')
                    .off('click', zipTools.warnOnTDAChange)
                    .on('click', zipTools.warnOnTDAChange);
                });
              } else {
                // no data to display?
              }
            }

          });

          // resubmit when zip changes
          $(window).on('ZIP_CODE_CHANGED', function () {
            var $noDealersText = $('#no-dealers-found');
            if ($noDealersText.is(':visible')) {
              $noDealersText.hide();
            }
            if (!('state' == Panel.searchType && !Panel.skipGlobalChangeZip)) {
              Panel.$selectSearchType.val('zip');
              Panel.$selectSearchType.trigger('change');
              setTimeout(function () {
                Panel.$inputText.val(zip.getCookiedDefaultFallback());
                Panel.submitSearch(false);
              }, 200);
            }
          });
        }

        // Dealer Search Page
        if ($('#dealer-search-page').length) {
          // prevent tabbing into hidden things.
          $('.js-dealer-map-expandable').attr('tabIndex', '-1');
          $('#search-more-dealers').attr('tabIndex', '-1');

          /*
          BAT-1822, enable autosearch if user has a transferZip.
          This means they're coming directly from a dealer-search form
          on the national site. it's possible to be here, under those
          conditions, and the zip code is still not marked as confirmed
          */
          var enableAutoSearch;
          if (cookies.getItem('isConfirmedZip') === 'true' || zipTools.transferZip()) {
            enableAutoSearch = true;
          }
          var Panel = new DealerPanel({
            $form: $('#dealer-search-page form'),
            $selectSearchType: $('#dealer-search-page #search-type select'),
            // $inputText: $('#dealer-search-page #search-value'),
            $inputText: $('#dealer-search-page .js-search-value:visible'), // BAT-4293
            $submit: $('#dealer-search-page #search-submit'),
            $resultsContainer: $('#dealer-search-page #search-result'),
            $searchMoreBtn: $('#dealer-search-page #search-more-dealers'),
            $searchLessBtn: $('#dealer-search-page #search-less-dealers'),
            $searchMore: $('#dealer-search-page #search-more-dealers'),
            $searchLess: $('#dealer-search-page #search-less-dealers'),
            panelSearch: false,
            autoSearch: enableAutoSearch,
            skipGlobalChangeZip: true,
            zipRedirectPath: zipTools.getSiteHomePath() + 'dealers/',
            maxResults: 5,
            dealerDataForMap: [],
            markers: [],

            onSearchComplete: function (data) {
              var self = this;
              // expanded = true,
              var pmaDealerData = [];
              var nonPmaDealerData = [];
              var resultTemplate = $('#template-dealerresult').html();
              var resultHandlebar;
              var nonPmaDealerDataStartCount;
              var providerId = $('#defaultzipcode').attr('providerid');
              var miraiOnly = $('#mirai-dealer-check').prop('checked') || false;
              var $noDealersText = $('#no-dealers-found');
              var miraiDealerData = [];
              var miraiDealerDataPMA = [];


              // enable tabbing to the things once hidden
              $('.js-dealer-map-expandable').attr('tabIndex', '0');
              $('#search-more-dealers').attr('tabIndex', '0');

              // re-enable the submit button
              self.$submit.removeAttr('disabled');
              function multilineTrim(htmlString) {
                return htmlString.split('\n').map($.trim).filter(function (line) {
                  return line != '';
                }).join('\n');
              }
              /* SHOW AND HIDE SOME MIRAI ELELENTS, IF APPLICABLE */
              $('.hor-stroke-150').hide();
              $('#mirai-pipe-bar').addClass('mirai-pipe-bar-active');

              /**
               *  This function takes an array as the first parameter
               *  and returns the array with unique elements.  For example
               *  the marker data looks like [1,2,1,2,3,4], and this
               *  function returns [1,2,3,4].
               *  lad
               */
              function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
              }

              function initStateMapWithDealerData(markers, dealerData, mapContId) {
                // send unique map markers to the Map creation module
                var uniqueMarkers = markers.filter(onlyUnique);
                var uniqueDealerData = dealerData.filter(onlyUnique);
                var mapContId = mapContId || 'map-canvas-dealer-search';
                buildMap()
                  .then(function (MapsConstructor) {
                    var maps = new MapsConstructor({
                      kind: 'multimarker', // image or map
                      markers: uniqueMarkers,
                      numberedMarkers: true,
                      dealerData: uniqueDealerData,
                      mapOptions: {
                        zoom: 30,
                        backgroundColor: '#fff'
                      },
                      mapElement: document.getElementById(mapContId)
                      // mapElement: document.getElementsByClassName('map-render')
                    }); // END maps var

                    $('#search-result-wrap').addClass('view-results-visible');
                    Panel.currentMap = maps; // BAT-2815 attach this current map to our Panel, so we can access it elsewhere. This means we can NOT build mobile version at the same time
                  })
                  .catch(function (err) { console.log('maps err:', err); });
              }

              function drawDealers() {
                self.markers = $.map(self.dealerDataForMap, function (element, index) {
                  /* console.group('Markers for use on Map');
                    console.log('dealerDataForMap: ', self.dealerDataForMap);
                    console.log('element: ', element);
                    console.log('element.coords: ', element.coords);
                  console.groupEnd(); */
                  return element.coords;
                });

                // ONly invoke initStateMapWithDealerData on each specific FAD page
                // specific to the FAD page, default skin (NOT the FAD smaller map skin)
                if ($('#dealer-search-page.page-dealer-search-skin-default').length > 0) {
                  initStateMapWithDealerData(self.markers, self.dealerDataForMap, 'map-canvas-dealer-search');
                }

                resultHandlebar = Handlebars.hcompile(resultTemplate, {
                  result: self.dealerDataForMap
                });

                $('.js-results-present').css('opacity', '1');
                $('.data-results').html(multilineTrim(resultHandlebar));
                if (!self.initialLoad) {
                  self.resultsStartCount = self.dealerDataForMap.length;
                  self.initialLoad = true; // reset on search submit in dealer panel
                } else {
                  // USER HAS SELECTED VIEW MORE RESULTS.
                  var nextFocusableNum;
                  if (self.dealerDataForMap.length <= self.maxResults) {
                    // ONLY FIRST PMAS WERE DISPLYED, NEED TO STORE THIS INFO SO WE CAN PICK THE NEXT OF THIS GROUP THAT GETS'S EXPOSED
                    nextFocusableNum = (self.resultsStartCount);// - 1);// (self.dealerDataForMap.length - self.resultsStartCount) - 1;// + 1;
                  } else {
                    nextFocusableNum = (self.dealerDataForMap.length - self.maxResults);// pick the first of the returned set.
                  }
                  // focusable method defined and extends jquery in tabControl.js
                  if (tabControl.usingKeys) {
                    var focusableItem = $('.js-result-parent:eq(' + nextFocusableNum + ')').find(':focusable:visible').first();
                    focusableItem.focus();
                  }
                }
                // BAT-2815, new Find-a-Dealer-smaller-map-skin only:
                function fadSearch() {
                  if (responsive() === 'sm') {
                    initStateMapWithDealerData(self.markers, self.dealerDataForMap, 'map-canvas-dealer-search-mobile');
                    $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
                      var target = $(e.target).attr('href'); // activated tab
                      if (target === '#dealers-map') {
                        initStateMapWithDealerData(self.markers, self.dealerDataForMap, 'map-canvas-dealer-search-mobile');
                      }
                    });
                  } else {
                    initStateMapWithDealerData(self.markers, self.dealerDataForMap, 'map-canvas-dealer-search');
                    var navHeight = $('.nav-sticky').outerHeight();
                    var top; // can only get the top the first time
                    if (window.bat.initTopMap) {
                      top = window.bat.initTopMap;
                    } else {
                      top = $('#map-tools-cont').offset().top - parseFloat($('#map-tools-cont').css('marginTop').replace(/auto/, 0));
                      window.bat.initTopMap = top;
                    }
                    var footTop = $('#footer-wrapper-row').offset().top - parseFloat($('#footer-wrapper-row').css('marginTop').replace(/auto/, 0));
                    var maxY = footTop - $('#map-tools-cont').outerHeight() - 10;

                    $(window).off().on('scroll', function (evt) {
                      var y = $(this).scrollTop() + navHeight;
                      if (y > top) {
                        if (y < maxY) {
                          $('#map-tools-cont').addClass('is-fixed').removeAttr('style');
                        } else {
                          $('#map-tools-cont').removeClass('is-fixed').css({
                            position: 'absolute',
                            right: 0,
                            left: 0,
                            top: (maxY - top) + 'px'
                            // top: (maxY - top) + 'px'
                          });
                        }
                      } else {
                        $('#map-tools-cont').removeClass('is-fixed');
                      }
                    });
                  }
                }

                if ($('#dealer-search-page.page-dealer-search-skin-smaller-map').length > 0) {
                  fadSearch();
                  var initBP = responsive();
                  $(window).on('breakpoint', function () {
                    // redo layout on BP chage
                    var newBP = responsive();
                    if (initBP === 'sm' && (newBP === 'md' || newBP === 'lg')) {
                      initBP = newBP;
                      $('a[href="#dealers-list"]').trigger('click');
                      fadSearch();
                    } else if (newBP === 'sm' && (initBP === 'md' || initBP === 'lg')) {
                      initBP = newBP;
                      fadSearch();
                    }
                  });
                }
                window.bat.util.loader.hideLoader();

                ctas.compare(undefined, undefined, self.$resultsContainer);
                // Add custom CTA link logic here
                $("a[data-destination='custom']").each(function (i, customCTALink) {
                  var $this = $(this);
                  var customUrl = $this.attr('href');
                  // console.log("customUrl: " + customUrl);
                  var customUrlArr = customUrl.split('/'); // split it into an array, so we can drop the unused parts
                  if (customUrlArr[1] == 'sites') {
                    customUrlArr.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
                    customUrlArr.unshift('/' + tdaConfig.site.context_url);
                  }

                  var finalUrl = customUrlArr.join('/'); // create URL from array
                  // console.log("finalUrl: " + finalUrl);
                  $this.attr('href', finalUrl);
                });

                var isSafari = $('html').hasClass('safari');
                var isMac = $('html').hasClass('mac');
                var isFF = $('html').hasClass('firefox');

                $('.js-maps').each(function () {
                  // if this is our mobile only "view in maps" links, handle differently :(
                  var address = '';
                  if ($(this).parent().parent().hasClass('visible-sm')) {
                    address = $(this).closest('.js-result-parent').find('a.js-maps').html().split('<br>')[0];
                  } else {
                    address = $(this).html().split('<br>')[0];
                  }
                  address = address.replace(',', '');// example: "1605 VFW ParkwayBoston, MA 02132"
                  var urlfa = address.replace(/ /g, '+');
                  var mapurl = 'https://maps.google.com/?daddr=' + urlfa;
                  // if this is safari or Mac Firefox, let's use apple maps. (Chrome on mac does not handle maps.apple links nicely)
                  if (isSafari || (isMac && isFF)) {
                    mapurl = 'https://maps.apple.com/?daddr=' + urlfa;
                  }
                  // console.log('MAP URL from new FAD page: ', mapurl);
                  $(this).attr('href', mapurl);
                });
              }

              // check if doing a new search
              if (self.currentResultNum === 1 && !self.$searchMoreBtn.data('pendingSearchData')) {
                // doing a new search, so replace results
                self.$searchMoreBtn.show();

                // get pma dealer data
                pmaDealerData = $.grep(data, function (element, index) {
                  return element.is_pma;
                });

                // get mirai dealers from PMA dealers
                miraiDealerDataPMA = $.grep(pmaDealerData, function (element, index) {
                  return element.is_mirai;
                });

                // get all mirai dealers
                miraiDealerData = $.grep(data, function (element, index) {
                  return element.is_mirai;
                });

                // BAT-1159: City/Name Dealer Searches Should Use Proximity instead of PMA Logic
                var searchTypeValue = self.searchType;

                // Display only PMA Dealer if search on ZIP (BAT-1159)
                if ((searchTypeValue === 'zip' || (searchTypeValue === 'state' && miraiOnly)) && pmaDealerData.length) {
                  if (searchTypeValue === 'state' && miraiOnly) {
                    self.dealerDataForMap = data;

                    if (self.dealerDataForMap[0].dealer_code === self.dealerDataForMap[1].dealer_code) {
                      self.dealerDataForMap.shift();
                    }

                    // remove pending search data
                    self.$searchMoreBtn.removeData('pendingSearchData');

                    // after search, adjust start index
                    self.currentResultNum = self.currentResultNum + self.maxResults;
                  } else {
                    self.dealerDataForMap = pmaDealerData; // we have pma dealers to display
                  }
                  // check if there is pending data to display after the pma dealers
                  if (pmaDealerData.length !== data.length && !(searchTypeValue === 'state' && miraiOnly)) {
                    self.$searchMoreBtn.data('pendingSearchData', data); // store pending search data (the original data)
                  }
                // non-PMA results (city/state search OR Deep link search (BAT-2638))
                } else {
                  self.dealerDataForMap = data;
                }

                // Can we display our 'Text Your Local Dealership' button?
                var showClickToTextDealer = $('#defaultzipcode').attr('dealerresultstext');
                if (showClickToTextDealer === 'Yes') {
                  showClickToTextDealer = true;
                } else {
                  showClickToTextDealer = false;
                }

                /*
                IF we have results...
                Add clickToChat property (available via external API) to each object in our self.dealerDataForMap array
                Store each in our deferredChatPresences array. When all of those are done, we may proceed
                */
                if (self.dealerDataForMap.length) {
                  var deferredChatPresences = [];
                  for (var i = 0; i < self.dealerDataForMap.length; i++) {
                    self.dealerDataForMap[i].resultCount = (i + 1); // add result count property (only added in this portion of our IF statement)
                    self.dealerDataForMap[i].providerId = providerId;
                    self.dealerDataForMap[i].show_marker_icon = true;
                    self.dealerDataForMap[i].clickToText = showClickToTextDealer;
                    // push each promised object (response from window.bat.dealerChatPresence) into our array of deferreds
                    deferredChatPresences.push(window.bat.dealerChatPresence(providerId, self.dealerDataForMap[i].dealer_code, 'dealerresultschat'));
                  }

                  /*
                  when all of our promise objects are done, we can use the returned arguments (true or false)
                  to update the clickToChat property on each self.dealerDataForMap obj
                  */
                  $.when.apply(this, deferredChatPresences).done(function () {
                    var responseArr = arguments;
                    for (var j = 0; j < self.dealerDataForMap.length; j++) {
                      // if the responseArr permits us to show CTA on dealerResultsPage,
                      // then update our current dealerData obj with it's contactatonce online status
                      if (responseArr[j].showOnDealerResultsPage === true) {
                        self.dealerDataForMap[j].clickToChat = responseArr[j].isOnline;
                      }
                    }
                    drawDealers();
                  });
                }

                // enable search more button if needed, trying to make the reasoning clear with multiple conditions
                if (miraiOnly && miraiDealerDataPMA.length && miraiDealerDataPMA.length !== miraiDealerData.length) {
                  // there are miraiPMA dealers and mirai non-pma dealers to show after miraiPMA dealers
                  if (self.$searchMoreBtn.attr('disabled') === 'disabled') {
                    self.$searchMoreBtn.html(self.$searchMoreBtn.data('copy'));
                    self.$searchMoreBtn.removeAttr('disabled');
                  }
                } else if (pmaDealerData.length && pmaDealerData.length !== data.length) {
                  // there are pma dealers and non-pma dealers to show after pma dealers
                  if (self.$searchMoreBtn.attr('disabled') === 'disabled') {
                    self.$searchMoreBtn.html(self.$searchMoreBtn.data('copy'));
                    self.$searchMoreBtn.removeAttr('disabled');
                  }
                } else if (pmaDealerData.length && pmaDealerData.length === data.length && !(true === self.$searchMoreBtn.data('isDisabledPending'))) {
                  // there are only pma dealers to show, and no disabled is pending
                  if (self.$searchMoreBtn.attr('disabled') === 'disabled') {
                    self.$searchMoreBtn.html(self.$searchMoreBtn.data('copy'));
                    self.$searchMoreBtn.removeAttr('disabled');
                  }
                } else if (!pmaDealerData.length && !(true === self.$searchMoreBtn.data('isDisabledPending'))) {
                  // there are only non-pma dealers to show, and no disabled is pending
                  if (self.$searchMoreBtn.attr('disabled') === 'disabled') {
                    self.$searchMoreBtn.html(self.$searchMoreBtn.data('copy'));
                    self.$searchMoreBtn.removeAttr('disabled');
                  }
                }
              } else if (self.dealerDataForMap.length < 50 - self.maxResults) {
                if (self.currentResultNum === 1) {
                  self.dealerDataForMap = data;
                } else {
                  self.dealerDataForMap = self.dealerDataForMap.concat(data);
                }

                if (self.dealerDataForMap[0].dealer_code === self.dealerDataForMap[1].dealer_code) {
                  self.dealerDataForMap.shift();
                }

                // get non-pma dealer data
                nonPmaDealerData = $.grep(data, function (element, index) {
                  return !element.is_pma;
                });

                // get start count of non pma dealer results
                nonPmaDealerDataStartCount = data.length - nonPmaDealerData.length + 1;

                // Can we display our 'Text Your Local Dealership' button?
                var showClickToTextDealer = $('#defaultzipcode').attr('dealerresultstext');
                if (showClickToTextDealer === 'Yes') {
                  showClickToTextDealer = true;
                } else {
                  showClickToTextDealer = false;
                }

                /*
                IF we have results...
                Add clickToChat property (available via external API) to each object in our self.dealerDataForMap array
                Store each in our deferredChatPresences array. When all of those are done, we may proceed
                */
                if (self.dealerDataForMap.length) {
                  var deferredChatPresences = [];
                  for (var i = 0; i < self.dealerDataForMap.length; i++) {
                    self.dealerDataForMap[i].providerId = providerId;
                    self.dealerDataForMap[i].show_marker_icon = true;
                    self.dealerDataForMap[i].clickToText = showClickToTextDealer;
                    // push each promised object (response from window.bat.dealerChatPresence) into our array of deferreds
                    deferredChatPresences.push(window.bat.dealerChatPresence(providerId, self.dealerDataForMap[i].dealer_code, 'dealerresultschat'));
                  }

                  /*
                  when all of our promise objects are done, we can use the returned arguments (true or false)
                  to update the clickToChat property on each self.dealerDataForMap obj
                  */
                  $.when.apply(this, deferredChatPresences).done(function () {
                    var responseArr = arguments;
                    for (var j = 0; j < self.dealerDataForMap.length; j++) {
                      // if the responseArr permits us to show CTA on dealerResultsPage,
                      // then update our current dealerData obj with it's contactatonce online status
                      if (responseArr[j].showOnDealerResultsPage === true) {
                        self.dealerDataForMap[j].clickToChat = responseArr[j].isOnline;
                      }
                    }
                    drawDealers();
                  });
                }

                // remove pending search data
                self.$searchMoreBtn.removeData('pendingSearchData');

                // after search, adjust start index
                self.currentResultNum = self.currentResultNum + self.maxResults;

                // disable search more button if needed
                if (self.$searchMoreBtn.data('isDisabledPending') === true) {
                  self.$searchMoreBtn.attr('disabled', 'disabled');
                  self.$searchMoreBtn.removeData('isDisabledPending');
                  self.$searchMoreBtn.fadeOut();
                } else {
                  self.$searchMoreBtn.show();
                }
              } else {
                // console.log('NON PMA NO MARKERS DEALER DATA!', data);
                resultHandlebar = Handlebars.hcompile(resultTemplate, {
                  result: data
                });
                $('.data-results').append(multilineTrim(resultHandlebar));
              }
              // ensure links to different TDA get a warning message
              $('.data-results a[data-tda-code]').off('click', zipTools.warnOnTDAChange).on('click', zipTools.warnOnTDAChange);

              // BAT-2638 save/update deep-link data
              function saveDeepLinkData() {
                var newEndForDeepLink;
                var newHash;
                // if it's a deepLink already, use existing end value, else grab the latest END number
                if (self.searchType === 'deep') {
                  newEndForDeepLink = self.service.deep.params.end;
                } else {
                  newEndForDeepLink = self.resultEndNum;
                }

                // If there was ONLY PMA dealers showing at the time of a 'view dealer-details' click, we need to let our deeplink know
                // if pmaDealerData.length (if there's any PMA data, then this means the user has NOT clicked "more" yet?)
                if (self.searchType === 'zip' && pmaDealerData.length > 0) {
                  newEndForDeepLink = pmaDealerData.length;
                }

                // grab state query (zip), queryText (user entered txt) and save that in the cookie too!
                if (self.searchType === 'state') {
                  newHash = $.extend(self.deepLinkHash, { end: newEndForDeepLink, query: self.serviceParams.zipcode, queryText: self.$inputText.val() });
                } else {
                  newHash = $.extend(self.deepLinkHash, { end: newEndForDeepLink, queryText: self.$inputText.val() }); // extend our deepLinkHash with the new END number
                }


                // store this in a cookie, for retrieval later (when ?deep=true is present on dealer search, this cookie will be retrieved)
                var tomorrow = new Date((new Date()).valueOf() + 1000 * 3600 * 24);
                cookies.setItem('dealerSearchDeep', JSON.stringify(newHash), tomorrow, '/', zipTools.getCrossDomainCookieDomain());
              }
              saveDeepLinkData();

              // update datalayer with form data
              function updateDataLayer() {
                var $componentToUpdate = $('div[data-component-name="Find-a-Dealer"]');
                var currDataLayer = $componentToUpdate.data('layer');
                var searchTermUsed = $(self.$inputText).val();
                var dataToAdd;
                // drop specific components that were added here?
                dataToAdd = {
                  'dealer_search_term': searchTermUsed,
                  'dealer_search_type': self.searchType,
                  'dealer_search_results_count': String(self.dealerDataForMap.length),
                  'dealer_search_brand': 'Toyota'
                };
                $.extend(window.dataLayerBAT.data, dataToAdd);
              }

              // fire page based km-dealer-search NO MATTER what
              updateDataLayer();
              window.dataLayerBAT.utils.triggerEvent(document, 'DL.PAGE_LOAD');
            }
          });

          $('.js-dealer-map-expandable').on('click', function (e) {
            e.preventDefault();
            var batMap = Panel.currentMap; // BAT map obj, NOT google one
            $('.search-result-left').fadeOut(function () {
              $('#search-result-wrap-inner').toggleClass('map-is-expanded');
              var mapId = document.getElementById('map-canvas-dealer-search'); // avoid merge conflict, use this method in trigger resize
              setTimeout(function () {
                if (window.bat.batMapMarker) {
                  batMap.infowindow.close();
                }
                batMap.google.maps.event.trigger(mapId, 'resize');
              }, 0);
              $('.search-result-left').fadeIn(1000);
            });
          });

          $('.js-search-type').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var searchType = $this.data('searchtype');
            if (searchType === 'zip') {
              $('.js-search-type-dealer').show();
              Panel.$inputText.next('.input-group-addon').removeClass('addon-hidden');
            } else {
              $('.js-search-type-zip').show();
              Panel.$inputText.next('.input-group-addon').addClass('addon-hidden');
            }
            $this.hide();
            Panel.$selectSearchType.val(searchType).change();
          });

          /*
          Setup autolocate click event
          this is specific to the Find a Dealer auto-location
          all modals use .js-autolocate, attached in zip-tools.js
          */
          $('#autolocate').on('click', function () {
            zipTools.geoLocationZip.detect(zipTools.reLoadDealerSearch, zipTools.reLoadDealerSearchWithoutZip);
          });

          // BAT-4047 ADA
          $('#autolocate').on('keydown', function (event) {
            if (event.keyCode === 13) {
              $('#autolocate').trigger('click');
            }
          });
          // If zip is confirmed, remove our show-welcome layout
          if (cookies.getItem('isConfirmedZip') === 'true') {
            $('form.m-dealer-search').removeClass('show-welcome');
          } else {
            $('form.m-dealer-search').removeClass('is-loading');
          }

          // resubmit when zip changes
          $(window).on('ZIP_CODE_CHANGED', function () {
            if (!(Panel.searchType === 'state' && !Panel.skipGlobalChangeZip)) {
              Panel.$selectSearchType.val('zip');
              Panel.$selectSearchType.trigger('change');
              setTimeout(function () {
                Panel.$inputText.val(zip.getCookiedDefaultFallback());
                Panel.submitSearch(false);
              }, 200);
            }
          });
        }

        // -------------------------------------------------------
        // dealer search within:
        // Request a Quote
        // Schedule a Test Drive
        // Contact a Dealer
        // no longer uses dealer panel. Moved to features/slp
        // -------------------------------------------------------
      });
    }
  };

  return dealerPanelComponents;
});

